import { ImageModel, ConversationModel, ConversationType } from '@/models';

export type Image = ImageModel;

type Conversation = ConversationModel;

export { ConversationType };

export type CreateChatConversationPayload = {
  title: string;
  type: string;
  type_id: number;
  type_code: string;
  type_image: string;
};
export type RemindProductType = {
  product_id: number;
  remind: boolean;
};
export type RemindProductResponse = {
  product_id: number;
  remind: boolean;
};
export type ConversationQueryResponse = { data: Conversation };
